/*  HOSTNAME: 'http://localhost',
    HTTP_PORT: 8989,
    HTTPS_PORT: 4433,
*/
const TargetAPIUrlLocal = Object.freeze({
    HOSTNAME: 'http://localhost',
    HTTP_PORT: 8989,
    HTTPS_PORT: 4433,
});

const TargetAPIUrlRemote = Object.freeze({
    HOSTNAME: 'https://successfrequencyapi-dev.up.railway.app',
    HTTP_PORT: '',
    HTTPS_PORT: '',
});

const TargetAPIUrlRKRemote = Object.freeze({
    HOSTNAME: 'https://thriving-empathy-425b.up.railway.app',
    HTTP_PORT: '',
    HTTPS_PORT: '',
});

const TargetAPIPath = Object.freeze({
    API_AUTH_LOGIN_PATH: '/api/auth/login',
    API_AUTH_REGISTER_PATH: '/api/auth/register',
    API_AUTH_LOGOUT_PATH: '/api/auth/logout',
    API_QUESTIONNAIRE_PATH: '/api/questionnaires',
    API_QUESTIONNAIRE_SUBMISSION_PATH: '/api/questionnaires/submission',
    API_RESPONSE_REPORT_PATH: '/api/questionnaires/responsereport',
    API_UPDATE_PASSWORD_CREDENTIALS : '/api/users/credentials',
    API_RESOURCES_PATH : '/api/resources',
});



const TargetApiUrlAndPathLocal = Object.assign({}, TargetAPIUrlLocal , TargetAPIPath );
const TargetApiUrlAndPathRemote = Object.assign({}, TargetAPIUrlRemote , TargetAPIPath );
const TargetApiUrlAndPathRKRemote = Object.assign({}, TargetAPIUrlRKRemote , TargetAPIPath );

const TargetApiUrlAndPath = TargetApiUrlAndPathRKRemote;

module.exports = TargetApiUrlAndPath;